import gql from 'graphql-tag';

import { Query } from 'core/index';

import { PROJECT_CONNECTION_FIELDS } from 'apps/project/gql';
import { ISSUE_FIELDS } from 'apps/issueTracker/gql';
import {
  PROFILE_THREAD_CONNECTION_FIELDS,
  PROFILE_CONNECTION_FIELDS,
} from 'apps/profile/gql';
import { INITIATIVE_CONNECTION_FIELDS } from 'apps/initiative/gql/fragments';
import { STORY_CONNECTION_FIELDS } from 'apps/story/gql';

export const PROJECTS = gql`
  ${PROJECT_CONNECTION_FIELDS}
  query WhiteLabelProjects(
    $batchSize: Int
    $cursor: String
    $sortBy: String
    $contains: [String!]
    $notContains: [[String]]
    $filterBy: [[String!]]
    $whitelabels: [String]
  ) {
    projects(
      first: $batchSize
      after: $cursor
      sortBy: $sortBy
      contains: $contains
      notContains: $notContains
      filterBy: $filterBy
      whitelabels: $whitelabels
    ) {
      ...projectConnectionFields
    }
  }
`;
export class WhiteLabelProjectsQuery extends Query {
  static conf = {
    GQL: PROJECTS,
    varNames: [
      'batchSize',
      'cursor',
      'sortBy',
      'contains',
      'notContains',
      'filterBy',
      'whitelabels',
    ],
    resultPath: 'projects',
  };
}

const ISSUES = gql`
  ${ISSUE_FIELDS}
  query Issues(
    $batchSize: Int
    $cursor: String
    $sortBy: String
    $filterBy: [[String!]]
    $whitelabels: [String]
  ) {
    issues(
      first: $batchSize
      after: $cursor
      sortBy: $sortBy
      filterBy: $filterBy
      whitelabels: $whitelabels
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
      edges {
        cursor
        node {
          ...issueFields
        }
      }
    }
  }
`;

export class WhiteLabelIssuesQuery extends Query {
  static conf = {
    GQL: ISSUES,
    varNames: ['batchSize', 'cursor', 'sortBy', 'filterBy', 'whitelabels'],
    resultPath: 'issues',
  };
}

// TODO remove once we can do beter filtering and then do
// api_tracker.viralresponse_query_filter_project_tag based on args, not as new top level
const VIRAL_ISSUES = gql`
  ${ISSUE_FIELDS}
  query ViralIssues(
    $batchSize: Int
    $cursor: String
    $sortBy: String
    $contains: [String!]
    $filterBy: [[String!]]
  ) {
    viralresponseIssues(
      first: $batchSize
      after: $cursor
      sortBy: $sortBy
      contains: $contains
      filterBy: $filterBy
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
      edges {
        cursor
        node {
          ...issueFields
        }
      }
    }
  }
`;

export class ViralIssuesQuery extends Query {
  static conf = {
    GQL: VIRAL_ISSUES,
    varNames: ['batchSize', 'cursor', 'sortBy', 'filterBy', 'contains'],
    resultPath: 'viralresponseIssues',
  };
}

export const PROFILES = gql`
  ${PROFILE_CONNECTION_FIELDS}
  query Profiles(
    $batchSize: Int
    $cursor: String
    $sortBy: String
    $contains: [String!]
    $filterBy: [[String!]]
    $whitelabels: [String]
  ) {
    profiles(
      first: $batchSize
      after: $cursor
      sortBy: $sortBy
      contains: $contains
      filterBy: $filterBy
      whitelabels: $whitelabels
    ) {
      ...profileConnectionFields
    }
  }
`;

export class WhiteLabelProfilesQuery extends Query {
  static conf = {
    GQL: PROFILES,
    varNames: [
      'batchSize',
      'cursor',
      'sortBy',
      'contains',
      'filterBy',
      'whitelabels',
    ],
    resultPath: 'profiles',
  };
}

const INITIATIVES_QUERY = gql`
  ${INITIATIVE_CONNECTION_FIELDS}
  query Initiatives(
    $batchSize: Int
    $cursor: String
    $sortBy: String
    $contains: [String!]
    $filterBy: [[String!]]
    $whitelabels: [String]
  ) {
    initiatives(
      first: $batchSize
      after: $cursor
      sortBy: $sortBy
      contains: $contains
      filterBy: $filterBy
      whitelabels: $whitelabels
    ) {
      ...initiativeConnectionFields
    }
  }
`;

export class WhiteLabelInitiativesQuery extends Query {
  static conf = {
    GQL: INITIATIVES_QUERY,
    varNames: [
      'batchSize',
      'cursor',
      'sortBy',
      'contains',
      'filterBy',
      'whitelabels',
    ],
    resultPath: 'initiatives',
  };
}

const STORIES = gql`
  ${STORY_CONNECTION_FIELDS}
  query Stories(
    $batchSize: Int
    $cursor: String
    $sortBy: String
    $contains: [String!]
    $filterBy: [[String!]]
    $whitelabels: [String]
  ) {
    stories(
      first: $batchSize
      after: $cursor
      sortBy: $sortBy
      contains: $contains
      filterBy: $filterBy
      whitelabels: $whitelabels
    ) {
      ...storyConnectionFields
    }
  }
`;
export class WhiteLabelStoriesQuery extends Query {
  static conf = {
    GQL: STORIES,
    varNames: [
      'batchSize',
      'cursor',
      'sortBy',
      'contains',
      'filterBy',
      'whitelabels',
    ],
    resultPath: 'stories',
  };
}

const ALL_THREADS_QUERY = gql`
  ${PROFILE_THREAD_CONNECTION_FIELDS}
  query Threads(
    $batchSize: Int
    $cursor: String
    $sortBy: String
    $notContains: [[String]]
    $contains: [String!]
    $filterBy: [[String!]]
    $whitelabels: [String]
  ) {
    threads(
      first: $batchSize
      after: $cursor
      sortBy: $sortBy
      contains: $contains
      notContains: $notContains
      filterBy: $filterBy
      whitelabels: $whitelabels
    ) {
      ...threadConnectionFields
    }
  }
`;

export class WhiteLabelThreadsQuery extends Query {
  static conf = {
    GQL: ALL_THREADS_QUERY,
    varNames: [
      'batchSize',
      'cursor',
      'sortBy',
      'contains',
      'notContains',
      'filterBy',
      'whitelabels',
    ],
    resultPath: 'threads',
  };
}
